import React, {Component, PropTypes} from 'react';
import {Button} from 'react-bootstrap';
import moment from 'moment';

import ReactTable from 'react-table';
import {defaultFilterMethod, includesInsensitive} from 'utils/table';
import {initializer, selectors} from 'utils/resourcerizer';
import {connect} from 'react-redux';
import {USERS_NS} from 'constants/index';

const usersInitializer = initializer(USERS_NS)
const usersSelectors = selectors(USERS_NS)

const mstp = (state,ownProps) => ({
  users: usersSelectors.findAll(state, (u) => (u.model == "Recruiter") )
})

class recruiterList extends Component {
  static propTypes = {
    recruiters: PropTypes.array
  };

  render() {
    const {isUpdating, all:recruiters, selectOne, users} = this.props;
    const columns = [
      {
        Header: '#',
        filterable: false,
        accessor: 'index',
        Cell: props => props.value+'.',
        maxWidth: 80
      },
      {
        Header: 'Name',
        accessor: 'fullName' // String-based value accessors!
      },
      {
        id: 'email',
        Header: 'Email',
        accessor: recruiter => {
          let u = users.find(u => u._id === recruiter.user);
          return (u && u.email) || 'null';
        },
      },
      {
        Header: 'Position',
        accessor: 'position',
        Cell: props => <span className="number">{props.value}</span> // Custom cell components!
      },
      {
        id: 'companyName', // Required because our accessor is not a string
        Header: 'Company',
        accessor: recruiter => ({
          name:recruiter.company.name,
          url:recruiter.company.socialMedia.websiteUrl
        }),
        filterMethod: (filter, row) => {
          return includesInsensitive(row[filter.id].name, filter.value);
        },
        Cell: props => {
          const {value: {url, name}} = props
          if(url) {
            return <a href={url} target="_blank">{name}</a>
          }else{
            return <span>{name}</span>
          }
        }
      },
      {
        Header: props => <span>Company Size</span>, // Custom header components!
        accessor: 'company.employeesAmount'
      },
      {
        Header: 'HQ Location', // Custom header components!
        accessor: 'company.headquartersLocation'
      },
      {
        id: 'actions',
        Header: 'Actions',
        sortable: false,
        filterable: false,
        accessor: recruiter => (
          <Button onClick={selectOne(recruiter._id)}>
            View Details
          </Button>
        )
      }
    ];

    const recruitersIndexed = recruiters && recruiters.map((el,index) => ({index:index+1, ...el})) //immutable

    return <ReactTable
      loading={isUpdating || !recruiters }
      data={recruitersIndexed}
      columns={columns}
      defaultFilterMethod={defaultFilterMethod}
      filterable />;
  }
}

const RecruiterList = usersInitializer(connect(mstp)(recruiterList))
export default RecruiterList;



// WEBPACK FOOTER //
// ./src/components/recruiters/DataGrid.jsx